import { Card } from '@uma/react-commons/dist/index';
import styled from 'styled-components';
import tokens from '@veneer/tokens';

export const DoNotSeeDeviceContainer = styled(Card)`
  margin-bottom: ${tokens.layout.size5};
`;
